export const LudumEventBus = new Vue();

// PRIVATE NOTES
export const NOTES_REMOVE_FILE = 'notes:remove-file';
export const NOTE_ADDED = 'notes:added';

export const REFRESH_AGENDA = 'refresh-agenda';
export const REFRESH_AGENDA_LITE = 'refresh-agenda-lite';
export const REFRESH_SESSION = 'refresh-session';
export const REFRESH_SQUADS = 'refresh-squads';
export const REFRESH_INTEGRATIONS = 'refresh-integrations';
export const REFRESH_MORNING_MONITORING = 'refresh-morning-monitoring';

export const CLOSE_SEARCH = 'close-search';

export const RESET_SESSION_FORM = 'reset-session-form';

export const WALL_POSTS_ADD = 'wall-posts-add';
export const WALL_POSTS_DELETE = 'wall-posts-delete';
export const WALL_POSTS_REPLIES_ADD = 'wall-posts-replies-add';
export const WALL_POSTS_REPLIES_DELETE = 'wall-posts-replies-delete';

export const CLOSE_MENU_DROPDOWN = 'close-menu-dropdown';
export const TOGGLE_NAVIGATION = 'toggle-navigation';
export const OPEN_NAVIGATION = 'open-navigation';
export const CLOSE_NAVIGATION = 'close-navigation';
export const OPEN_ADMIN_NAVIGATION = 'open-admin-navigation';
export const CLOSE_ADMIN_NAVIGATION = 'close-admin-navigation';

export const TOGGLE_FILTER = 'toggles-filter';

export const CALENDAR_OPEN_WEEKLY_SUMMARY = 'calendar:open-weekly-summary';

export const AUTO_IMPORT_RELOAD_FILES = 'auto-import:reload-files';

export const CLUB_MEMBERS_LOAD = 'club-members:load';

export const FILE_UPLOADED = 'file-uploaded';
export const IMAGE_UPLOADED = 'image-uploaded';

export const EQUIPMENT_CATEGORY_DELETED = 'equipment:category-deleted';
export const EQUIPMENT_EQUIPMENT_DELETED = 'equipment:equipment-deleted';
export const EQUIPMENT_EQUIPMENT_ASSIGNED = 'equipment:equipment-assigned';

export const REFRESH_CHALLENGES = 'challenges:refresh';

export const MINIMAX_FILE_UPDATED = 'minimax:file-updated';
export const MINIMAX_POINT_HIGHLIGHTED = 'minimax:point-highlighted';
export const MINIMAX_POINT_HIGHLIGHT_OUT = 'minimax:point-highlight-out';
export const MINIMAX_POINT_SELECTED = 'minimax:point-selected';
export const MINIMAX_RANGE_CHANGED = 'minimax:range-changed';

export const GRAPH_POINT_HIGHLIGHTED = 'graph:point-highlighted';
export const GRAPH_POINT_HIGHLIGHT_OUT = 'graph:point-highlight-out';

export const SESSION_RESULTS_LIVE_FOCUS_ON_MAP = 'session-results-live:focus-on-map';
export const SESSION_RESULTS_LIVE_HISTORY_DATA = 'session-results-live:history-data';
export const SESSION_RESULTS_LIVE_RESULT_RECEIVED = 'session-results-live:results-received';
export const SESSION_RESULTS_LIVE_MESSAGE_RECEIVED = 'session-results-live:message-received';

export const PROFILE_DATA_RELOAD = 'profile-data:reload';

export const SESSION_CREATED = 'session:created';
export const SESSION_CREATED_LITE = 'session:created-lite';
export const SESSION_LOCATION_CLOSED = 'session:location-closed';
export const SESSION_LOCATION_PICKED = 'session:location-picked';

export const REPORTS_RACING_PRINT = 'reports:racing:print';
export const REPORTS_RACING_PRINT_START = 'reports:racing:print:start';
export const REPORTS_RACING_PRINT_END = 'reports:racing:print:end';

export const QR_CONNETCTION_PRINT = 'qr-connection:print';
export const QR_CONNETCTION_PRINT_START = 'qr-connection:print:start';
export const QR_CONNETCTION_PRINT_END = 'qr-connection:print:end';

export const TELEMETRY_ANALYSIS_PRINT = 'telemetry:analysis:print';
export const TELEMETRY_ANALYSIS_PRINT_START = 'telemetry:analysis:print:start';
export const TELEMETRY_ANALYSIS_PRINT_END = 'telemetry:analysis:print:end';

export const REFRESH_CLUB = 'club:refresh';

export default LudumEventBus;
